
import * as React from 'react';
import { downloadItemsActionControlFacet, IDownloaderProps } from '../../../../controls/downloadItemsActionControl';
import {
  withSelectedItems,
  withCurrentItemAsFallback,
  IDecorateWithSelectedItemsProps,
  IDecorateWithCurrentItemAsFallbackProps
} from '../../../decorators/selectors';
import { WithItemCache, IItemCacheStateProps } from '../../../withItemCache/WithItemCache';
import { IWizardActionStateProps, BackgroundAction } from '../../../wizardAction/WizardAction';
import { malwareDetectedFacet } from '../../../../facets/ItemFacets';

export interface IItemDownloadActionProps {
  itemKeys: string[];
  downloader: React.ComponentType<IDownloaderProps>;
  maxFileSize?: number;
}

export class ItemDownloadAction extends React.PureComponent<IItemDownloadActionProps> {
  public render(): JSX.Element {
    const {
      itemKeys,
      downloader
    } = this.props;

    return (
      <WithItemCache>
        { ({ itemCache, dispatch }: IItemCacheStateProps) => {

          const [itemKey] = itemKeys;
          if (!itemKey) {
            return <BackgroundAction isAvailable={ false } />;
          }

          const isMalwareDetected = itemCache.demandItemFacet(malwareDetectedFacet, itemKey);
          if (isMalwareDetected) {
            return <BackgroundAction isAvailable={ false } />;
          }

          const controlHandler = itemCache.demandItemFacet(downloadItemsActionControlFacet, itemKey);

          const {
            downloader: Downloader,
            getDownloadData: getDownloadDataCreator,
            isAvailable
          } = downloadItemsActionControlFacet.evaluate(controlHandler)(itemCache, { // tslint:disable-line:max-line-length
            itemKeys: itemKeys,
            downloader: downloader,
            isAvailable: false
          });

          if (!Downloader || !getDownloadDataCreator || !isAvailable) {
            return <BackgroundAction isAvailable={ false } />;
          }

          const getDownloadData = () => dispatch(getDownloadDataCreator());

          return (
            <BackgroundAction
              isAvailable={ !isMalwareDetected && isAvailable }
              engagement={ {
                name: 'Download',
                isIntentional: true
              } }
            >
              { (wizardProps: IWizardActionStateProps) => {
                return (
                  <Downloader
                    itemKeys={ itemKeys }
                    getDownloadData={ getDownloadData }
                    maxFileSize={ this.props.maxFileSize }
                    { ...wizardProps }
                  />
                );
              } }
            </BackgroundAction>
          );
        } }
      </WithItemCache>
    );
  }
}

export type IDownloadActionProps = IDecorateWithSelectedItemsProps<IDecorateWithCurrentItemAsFallbackProps<IItemDownloadActionProps>>;

export const DownloadAction: React.ComponentType<IDownloadActionProps> =
  withSelectedItems()(withCurrentItemAsFallback()(ItemDownloadAction));
